// @ts-check

/**
 * Must be imported with the attribute defer="defer", when loaded to soon it doesn't have the templates loaded, we saw that in a console log, it was an empty element
 */
if (!customElements.get("ff-responsive-container")) {
  class FfResponsiveContainer extends HTMLElement {
    constructor() {
      super();
      this.style.display = "contents";
      /**
       * CSS media query which has to comply to render desktop content, otherwise mobile template would be rendered
       */
      this.mediaQuery = this.dataset.ffMediaQuery;
      if (this.dataset.hasOwnProperty("ffCreateImg")) {
        this.ffCreateImg();
      } else {
        this.ffRender();
      }
    }

    async ffRender() {
      let deferredSelector;
      /**
       * If a media query is not passed, then the desktop media will be rendered by default
       */
      if (
        this.mediaQuery == undefined ||
        window.matchMedia(this.mediaQuery).matches
      ) {
        deferredSelector = "template[data-ff-desktop]";
      } else {
        deferredSelector = "template[data-ff-mobile]";
      }
      /**
       * @type {HTMLTemplateElement | null}
       */
      const deferredTemplate =
        this.querySelector(deferredSelector) ||
        this.querySelector("template[data-ff-desktop]");

      if (deferredTemplate) {
        const deferredMedia =
          deferredTemplate.content.firstElementChild?.cloneNode(true);

        if (deferredMedia)
          this.insertAdjacentElement("afterend", deferredMedia);
        this.remove();
      }
    }

    async ffCreateImg() {
      if (
        this.mediaQuery == undefined ||
        window.matchMedia(this.mediaQuery).matches
      ) {
        var ffWidthDivider = this.dataset.ffDesktopWidthDivider;
        var ffImgHeight = this.dataset.ffImgHeightDesktop;
        var ffImgWidth = this.dataset.ffImgWidthDesktop;
        var ffImgUrl = this.dataset.ffImgUrlDesktop;
        var ffImgAlt = this.dataset.ffImgAltDesktop;
        var ffImgFetchPriority = this.dataset.ffImgFetchPriorityDesktop;
        var ffImgClass = this.dataset.ffImgClassDesktop;
        var ffImgLoading = this.dataset.ffImgLoadingDesktop;
      } else {
        var ffWidthDivider =
          this.dataset.ffMobileWidthDivider ||
          this.dataset.ffDesktopWidthDivider;
        var ffImgHeight =
          this.dataset.ffImgHeightMobile || this.dataset.ffImgHeightDesktop;
        var ffImgWidth =
          this.dataset.ffImgWidthMobile || this.dataset.ffImgWidthDesktop;
        var ffImgUrl =
          this.dataset.ffImgUrlMobile || this.dataset.ffImgUrlDesktop;
        var ffImgAlt =
          this.dataset.ffImgAltMobile || this.dataset.ffImgAltDesktop;
        var ffImgFetchPriority =
          this.dataset.ffImgFetchPriorityMobile ||
          this.dataset.ffImgFetchPriorityDesktop;
        var ffImgClass =
          this.dataset.ffImgClassMobile || this.dataset.ffImgClassDesktop;
        var ffImgLoading =
          this.dataset.ffImgLoadingMobile || this.dataset.ffImgLoadingDesktop;
      }

      const imgEl = document.createElement("img");
      if (this.dataset.hasOwnProperty("ffFitContainer")) {
        var widthReference =
          this.parentElement?.clientWidth || window.innerWidth;
      } else {
        var widthReference = window.innerWidth;
      }

      if (!ffImgHeight || !ffImgWidth || !ffImgUrl) {
        console.log("Missing img height or width");
        const imgWidth =
          widthReference / Number.parseFloat(ffWidthDivider || "1");

        if (ffImgUrl) {
          ffImgUrl = ffImgUrl.replace(
            "width=1",
            `width=${imgWidth.toFixed(0)}`
          );
          imgEl.src = ffImgUrl;
        } else {
          console.log("Missing img url");
        }
      } else {
        const imgWidth =
          widthReference / Number.parseFloat(ffWidthDivider || "1");
        const imgHeight =
          (Number.parseFloat(ffImgHeight) / Number.parseFloat(ffImgWidth)) *
          imgWidth;
        ffImgUrl = ffImgUrl.replace("width=1", `width=${imgWidth.toFixed(0)}`);
        imgEl.src = ffImgUrl;
        imgEl.width = imgWidth;
        imgEl.height = imgHeight;
      }

      imgEl.alt = ffImgAlt || "";
      imgEl.className = ffImgClass || "";
      imgEl.fetchPriority = ffImgFetchPriority || "";

      if (ffImgLoading != "eager" && ffImgLoading != "lazy") {
        console.log(`${ffImgLoading} is not 'eager' neither 'lazy`);
        imgEl.loading = "eager";
      } else {
        imgEl.loading = ffImgLoading || "eager";
      }

      this.insertAdjacentElement("afterend", imgEl);
      this.remove();
    }
  }

  customElements.define("ff-responsive-container", FfResponsiveContainer);
}
